export enum ButtonVariant {
  Blue,
  TransparentBlack,
}
